(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jobsite-challenges"] && !Shopify.designMode) return;
  try {
    
  class JobsiteTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-jobsite-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-jobsite-panel]'));

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleClick = (event) => {
      const tab = event.target.closest('[data-jobsite-tab]');
      if (!tab || !this.contains(tab)) return;

      this.activate(tab.dataset.jobsiteTab);
    };

    handleKeydown = (event) => {
      const currentTab = event.target.closest('[data-jobsite-tab]');
      if (!currentTab) return;

      const currentIndex = this.tabs.indexOf(currentTab);
      let nextIndex = currentIndex;

      if (['ArrowRight', 'ArrowDown'].includes(event.key)) nextIndex = (currentIndex + 1) % this.tabs.length;
      if (['ArrowLeft', 'ArrowUp'].includes(event.key)) nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex) return;

      event.preventDefault();
      const nextTab = this.tabs[nextIndex];
      this.activate(nextTab.dataset.jobsiteTab);
      nextTab.focus();
    };

    handleBlockSelect = (event) => {
      const tab = event.target.closest('[data-jobsite-tab]');
      if (tab) this.activate(tab.dataset.jobsiteTab);
    };

    activate(id) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.jobsiteTab === id;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.jobsitePanel !== id;
      });
    }
  }

  if (!customElements.get('jobsite-tabs')) {
    customElements.define('jobsite-tabs', JobsiteTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["projects-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-projects-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-projects-track]');
    const slides = [...slider.querySelectorAll('[data-projects-slide]')];
    const tabs = [...slider.querySelectorAll('[data-projects-tab]')];
    if (!slides.length) return;

    const cloneSet = () => {
      const fragment = document.createDocumentFragment();
      slides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.removeAttribute('data-projects-slide');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        fragment.append(clone);
      });
      return fragment;
    };

    track.prepend(cloneSet());
    track.prepend(cloneSet());
    track.append(cloneSet());
    track.append(cloneSet());

    const renderedSlides = [...track.children];
    renderedSlides.forEach((slide) => {
      const image = slide.querySelector('img');
      if (!image) return;
      image.loading = 'eager';
      image.decode?.().catch(() => {});
    });

    let active = Math.min(1, slides.length - 1);
    let position = slides.length * 2 + active;
    const updateTabs = () => tabs.forEach((tab, tabIndex) => { const selected = tabIndex === active; tab.setAttribute('aria-selected', selected); tab.tabIndex = selected ? 0 : -1; });

    const slideLeft = (slide) => slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
    const scrollToPosition = (behavior = 'smooth') => track.scrollTo({ left: slideLeft(renderedSlides[position]), behavior });
    const normalizePosition = () => {
      if (position >= slides.length && position < slides.length * 4) return;
      position = slides.length * 2 + active;
      track.style.scrollSnapType = 'none';
      track.scrollLeft = slideLeft(renderedSlides[position]);
      track.getBoundingClientRect();
      requestAnimationFrame(() => { track.style.scrollSnapType = ''; });
    };

    const select = (index, focus = false, direction = 0) => {
      const nextActive = (index + slides.length) % slides.length;

      if (direction) position += direction;
      else {
        const candidates = [1, 2, 3].map((setIndex) => setIndex * slides.length + nextActive);
        position = candidates.reduce((nearest, candidate) => Math.abs(candidate - position) < Math.abs(nearest - position) ? candidate : nearest, candidates[0]);
      }

      active = nextActive;
      updateTabs();
      scrollToPosition();
      if (focus) tabs[active].focus();
    };

    requestAnimationFrame(() => {
      scrollToPosition('auto');
      updateTabs();
    });
    tabs.forEach((tab, index) => tab.addEventListener('click', () => select(index)));
    slider.querySelector('[data-projects-previous]').addEventListener('click', () => select(active - 1, false, -1));
    slider.querySelector('[data-projects-next]').addEventListener('click', () => select(active + 1, false, 1));
    slider.addEventListener('keydown', (event) => { if (event.key === 'ArrowRight') { event.preventDefault(); select(active + 1, true, 1); } if (event.key === 'ArrowLeft') { event.preventDefault(); select(active - 1, true, -1); } });
    track.addEventListener('scrollend', () => {
      const center = track.scrollLeft + track.clientWidth / 2;
      position = renderedSlides.reduce((best, slide, index) => Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center) < Math.abs(renderedSlides[best].offsetLeft + renderedSlides[best].offsetWidth / 2 - center) ? index : best, 0);
      active = position % slides.length;
      updateTabs();
      normalizePosition();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
